import ursPostMessage from './ursPostMessage'
import logger from '../../common-scripts/logger'
import { createComponentBroadcast } from '../../common-scripts/componentBroadcast'
import { requestMethod } from '../../common-scripts/request'
import ursComponentSteps from '../urs-component-steps/ursComponentSteps'

let nextTicket = '' //保存接口二返回的ticket
let getCodeTicket = '' //接口一返回的ticket
$(function() {
  const { selector, actions } = ursPostMessage
  const $message = $(selector)
  const messageBroadcast = createComponentBroadcast(ursPostMessage)
  $('#contact-phone').focus(function() {
    $('.mark-err').hide()
  })
  $('#valid-code').focus(function() {
    $('.mark-err').hide()
  })
  //下发短信接口
  $('.get-valid-code').click(function() {
    let areaCode = $('.code-value').text()
    const regExe = /^[0-9]*$/
    const mobileNumber = $('#contact-phone').val() as string
    const testRes = regExe.test(mobileNumber)
    let mobile = ''
    if (areaCode.indexOf('+86') !== -1) {
      areaCode = ''
      mobile = `${mobileNumber}`.replace(/\s/gi, '')
    } else {
      areaCode = areaCode.split('+')[1]
      mobile = `${areaCode}-${mobileNumber}`.replace(/\s/gi, '')
    }
    if (testRes) {
      let time = 30
      const url = '/sms.s'
      const methods = 'POST'

      const data = {
        ticket: getCodeTicket,
        mobile,
      }
      logger.log('获取验证码')
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      $(this).attr('disabled', true)
      $(this).text(time <= 0 ? '获取验证码' : `${time}s`)
      const $that = $(this)
      const hander = setInterval(function() {
        if (time <= 0) {
          clearInterval(hander)
          $that.text('获取验证码')
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          $that.attr('disabled', false)
          return
        } else {
          $that.text(`${time--}s`)
        }
      }, 1000)
      requestMethod(url, methods, data)
        .then((datas) => {
          const { code, msg } = datas
          if (code == 200) {
            //接口二 获取服务端返回的ticket
            logger.log(datas.ticket)
            nextTicket = datas.ticket
          } else {
            logger.log(msg)
            logger.log(datas)
            $('.mark-err').hide()
            $('.err-phone').css('display', 'flex')
            $('.err-phone p').text(msg)

          }
        })
        .catch((e) => {
          logger.log(e)
        })
    } else {
      $('.mark-err').hide()
      $('.err-phone').css('display', 'flex')
    }
  })

  messageBroadcast.on(actions.show, () => {
    logger.log('modalBroadcast show....')
    $message.css('display', 'block')
    $('.form-info').css('margin-top', '24px')
    $('.channel').css('margin-top', '20px')
    $('.clause').css('margin-top', '32px')
    $('.urs-component-steps').css('height', '660px')
    $('.zhiyun').hide()
    $('.netease').show()
  })

  messageBroadcast.on(actions.hide, () => {
    logger.log('modalBroadcast hide....')
    $message.css('display', 'none')
  })
})

const ursiframes = document.getElementById('ursiframe') as HTMLElement

function onIframeLoad(): void {
  logger.log('onload执行')
  let key = 0
  const cbMap: any = {}
  const onRequest = function(options: any, cb: any) {
    logger.log('onrequest')
    options.key = ++key
    cbMap[options.key] = cb
    const ursiframe = document.getElementById('ursiframe') as HTMLIFrameElement
    const w = ursiframe.contentWindow
    w &&
      w.postMessage(
        options,
        'https://passport.youdao.com/webzj/act/urs-agent.html',
      )
  }

  const onMessage = function(event: any): void {
    const origin = event.origin
    const data = event.data
    if (data.from !== 'ursAgent') {
      //可用于区别其他的postmessage信息
      return
    }
    const cb = cbMap[data.key]
    if (cb) {
      delete cbMap[data.key]
      cb(data)
    }
  }
  //获取iframe返回的数据
  window.onmessage = onMessage

  const data = {
    method: 'cfmcl',
    data: {
      pd: 'youdao_zhiyun2018',
      pkid: 'ACT_qZYlCVk',
      pkht: 'ai.youdao.com',
    },
  }
  const { actions } = ursPostMessage
  const messageBroadcast = createComponentBroadcast(ursPostMessage)
  messageBroadcast.on(actions.gticket, () => {
    //接口执行接口一
    onRequest(data, function(data: any) {
      const result = data.result
      logger.log(data)
      if (result && result.code === '201') {
        logger.log('cfmcl正确返回：' + JSON.stringify(data))
        logger.log('cfmcl返回的ticket：' + result.ticket)
        getCodeTicket = result.ticket
      } else {
        logger.log('cfmcl错误返回：' + JSON.stringify(data))
      }
    })
  })

  messageBroadcast.on(actions.getCookie, (event: any, resData: any) => {
    const data = {
      method: 'vfsms',
      data: {
        pd: 'youdao_zhiyun2018',
        pkid: 'ACT_qZYlCVk',
        pkht: 'ai.youdao.com',
        sms: resData.validCode, //用户填入的短信
        tk: nextTicket || '', //接口二返回的ticket
        un: resData.mobileCode || '', //用户填入的手机号
      },
    }

    onRequest(data, function(data: any) {
      const actionsStep = ursComponentSteps.actions
      const stepBroadcastStep = createComponentBroadcast(ursComponentSteps)
      const result = data.result
      if (result && result.code === '201') {
        logger.log('vfsms正确返回：' + JSON.stringify(data))
        logger.log('vfsms登录成功：' + JSON.stringify(data))
        stepBroadcastStep.trigger(actionsStep.ticket, data)
      } else {
        logger.log('vfsms错误返回：' + JSON.stringify(data))
        stepBroadcastStep.trigger(actionsStep.ticket, data)
      }
    })
  })
}

ursiframes.onload = onIframeLoad
